import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import { Colors } from "../utils/colors";

export default function StepProgress({ step, totalSteps }) {
  const progress = (step / totalSteps) * 100;

  return (
    <Box sx={{ mb: 3 }}>
      <Typography sx={{ color: Colors.accent, mb: 1, fontWeight: 600 }}>
        Step {step} of {totalSteps}
      </Typography>

      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 10,
          borderRadius: 5,
          "& .MuiLinearProgress-bar": {
            backgroundColor: Colors.accent,
          },
          backgroundColor: Colors.muted,
        }}
      />
    </Box>
  );
}
